var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex space-x-5"},_vm._l((_vm.filters),function(filter,index){return _c('div',{key:filter,class:[
      'px-7',
      'py-2',
      _vm.activeClass(index),
      'rounded-md',
      'cursor-pointer',
      'text-sm',
      'font-semibold',
      'transition-all',
      'duration-300' ],on:{"click":function($event){return _vm.changeFilter(index)}}},[_vm._v(" "+_vm._s(filter)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }